import shopifyExtensionImg from 'assets/shopify_extension_instructions.png';

export const KNOWN_SITE_TYPES = [
  'WordPress',
  'WiX',
  'Shopify',
  'Squarespace',
  'Weebly',
  'Leadpages',
  'Duda',
  'Google Tag Manager',
  'Other',
] as const;
export type KnownSiteType = typeof KNOWN_SITE_TYPES[number];
export const isKnownSiteType = (siteType?: string): siteType is KnownSiteType =>
  !!(siteType && KNOWN_SITE_TYPES.find(t => t === siteType));

export const SHOPIFY_EXTENSION_INSTRUCTION = [
  {
    step: 'Complete the installation by enabling X-Ray in your Shopify theme editor',
    image: shopifyExtensionImg,
  },
];
